var styles = {
  "Droppable": "Online-Store-UI-DroppableRegion__Droppable_y9qaq",
  "DroppableInterior": "Online-Store-UI-DroppableRegion__DroppableInterior_14eqk",
  "DroppableBottom": "Online-Store-UI-DroppableRegion__DroppableBottom_r7259",
  "DroppableMid": "Online-Store-UI-DroppableRegion__DroppableMid_510gi",
  "DroppableTop": "Online-Store-UI-DroppableRegion__DroppableTop_1kyam"
};

export { styles as default };
